import { render, staticRenderFns } from "./stuart-status.vue?vue&type=template&id=2cbefea5"
import script from "./stuart-status.vue?vue&type=script&lang=ts"
export * from "./stuart-status.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\dev\\eatself\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cbefea5')) {
      api.createRecord('2cbefea5', component.options)
    } else {
      api.reload('2cbefea5', component.options)
    }
    module.hot.accept("./stuart-status.vue?vue&type=template&id=2cbefea5", function () {
      api.rerender('2cbefea5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/stuart-status.vue"
export default component.exports